import axios from "axios";

const ENV_BASE = process.env.REACT_APP_BACKEND_URL;
const bareHost = (h) => h.replace(/^www\./, "");
// Same site reached via www vs apex: call the API on the current origin so the
// apex -> www redirect never hits a cross-origin request.
const BASE = (() => {
  try {
    const u = new URL(ENV_BASE);
    const here = window.location;
    return u.host !== here.host && bareHost(u.host) === bareHost(here.host) ? here.origin : ENV_BASE;
  } catch {
    return ENV_BASE;
  }
})();
const TOKEN_KEY = "tt_admin_token";

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !/auth\/(login|refresh)/.test(cfg.url || "")) {
      cfg._retry = true;
      try {
        const { data } = await axios.post(`${BASE}/api/auth/refresh`, {}, { withCredentials: true });
        tokenStore.set(data.access_token);
        return api(cfg);
      } catch {
        tokenStore.clear();
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const assetUrl = (p) => (typeof p === "string" && p.startsWith("/api/") ? `${BASE}${p}` : p);
